import { SelectProps } from 'antd'
import { Select } from 'components/atoms'
import { SECTION_DAY_OPTIONS } from 'constants/options'
import { useProfile, useUtil } from 'hooks'
import { useTranslation } from 'react-i18next'

interface IProps extends SelectProps<any, any> {
  title?: string
  preventInput?: boolean
  placeholder?: string
  required?: boolean
}

const SelectSection = (props: IProps) => {
  const { title = '', placeholder = '', ...resProps } = props
  const { t } = useTranslation()
  const { getOptions } = useUtil()
  const { profile } = useProfile()

  const options = getOptions(SECTION_DAY_OPTIONS).map((shift) => {
    const findShift = profile?.shifts?.find((shi) => shi.shift === shift.value)
    let fromTo = findShift?.from ? `(${findShift?.from}-${findShift?.to})` : ''
    fromTo = ''
    return {
      ...shift,
      label: `${shift.label}${fromTo}`
    }
  })

  return (
    <Select
      showArrow
      title={t(title)}
      placeholder={t(placeholder)}
      options={options}
      filterOption={false}
      {...resProps}
    />
  )
}

export default SelectSection
